<template>
  <section class="hero">
    <!-- Background -->
    <div class="hero-background" :style="{ backgroundImage: `url(${backgroundImage})` }"></div>

    <!-- Content -->
    <div class="container-nzidoo hero-content">
      <div class="cta-card">
        <h1 class="card-title">{{ $t('hero.title') }}</h1>
        <router-link :to="{ name: 'productSell' }" class="btn btn-primary w-100 mb-2">{{ $t('hero.start')
          }}</router-link>
        <router-link :to="{ name: 'SellingStepsExplanation' }" class="btn btn-outline w-100">{{
          $t('hero.learnMore') }}</router-link>
      </div>
    </div>
  </section>
</template>

<script>
import hero_bg from '@/assets/img/hero-bg.webp';
export default {
  name: 'HeroComponent',
  data() {
    return {
      backgroundImage: hero_bg,
    }
  }
}
</script>

<style scoped>
/* ============ DEFAULT (Desktop / md and up) ============ */
.hero {
  position: relative;
  width: 100%;
  height: 600px;
  overflow: hidden;
  display: flex;
  align-items: s;
}

.hero-background {
  position: absolute;
  inset: 0;
  background-size: cover;
  background-position: center;
  filter: brightness(0.9);
  z-index: 1;
}

.hero-content {
  position: relative;
  z-index: 2;
  display: flex;
  align-items: center;
  padding-left: 60px;
  height: 100%;
}

.cta-card {
  background: rgba(255, 255, 255, 0.95);
  padding: 50px;
  border-radius: 12px;
  box-shadow: 0 20px 60px rgba(0, 0, 0, 0.3);
  max-width: 450px;
  backdrop-filter: blur(10px);
}

.card-title {
  font-size: 36px;
  font-weight: 700;
  color: var(--color-dark);
  margin-bottom: 16px;
}


/* ============ MOBILE (<768px): Vinted Style ============ */
@media (max-width: 767px) {
  .hero {
    height: auto;
    display: block;
    overflow: visible;
  }

  .hero-background {
    position: relative;
    width: 100%;
    height: 400px;
    filter: brightness(0.95);
    background-position: right center; /* 👈 show the right part of the image */
    background-size: cover;
  }

  .hero-content {
    position: relative;
    display: flex;
    justify-content: center;
    margin-top: -100px;
    padding: 0 20px;
  }

  .cta-card {
    width: 100%;
    max-width: 90%;
    text-align: center;
    background: white;
    border-radius: 20px;
    padding: 32px 20px;
    box-shadow: 0 6px 20px rgba(0, 0, 0, 0.1);
  }

  .card-title {
    font-size: 22px;
  }


}

</style>
